import { Quote, Star } from "lucide-react";
import { Chapter, Reveal } from "./Reveal";
import { REVIEWS } from "../../data/content";

export const Reviews = () => (
    <section id="reviews" data-testid="reviews-section" className="py-28 md:py-40">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
            <Chapter
                index="Ch. 07"
                eyebrow="Parent reviews"
                title={
                    <>
                        What families
                        <br />
                        <em className="text-navy">are saying.</em>
                    </>
                }
                testid="reviews-heading"
            />

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-ink/10 border border-ink/10">
                {REVIEWS.map((r, i) => (
                    <Reveal
                        key={r.author}
                        delay={(i % 3) * 0.08}
                        className={`bg-bone ${i === 0 ? "lg:col-span-2" : ""}`}
                    >
                        <figure
                            data-testid={`review-card-${r.author.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                            className="p-8 md:p-10 h-full flex flex-col"
                        >
                            <Quote className="w-5 h-5 text-oxblood mb-6 shrink-0" strokeWidth={1.5} />
                            <div
                                data-testid={`review-stars-${r.author.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                                className="flex gap-1 mb-4"
                            >
                                {[...Array(5)].map((_, s) => (
                                    <Star key={s} className="w-3.5 h-3.5 fill-oxblood text-oxblood" strokeWidth={1.5} />
                                ))}
                            </div>
                            <blockquote className="font-serif text-lg md:text-xl leading-relaxed text-ink flex-1">
                                {r.text}
                            </blockquote>
                            <figcaption className="mt-8 font-mono text-[11px] uppercase tracking-[0.25em] text-slate2">
                                — {r.author}
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
